export default {
      id: "sensors__battary_voltage-usage",
      viewBox: "0 0 48 29",
      url: __webpack_public_path__ + "img/icons.svg#sensors__battary_voltage",
      toString: function () {
        return this.url;
      }
    }